module.exports = __webpack_public_path__ + "static/PickUpSport-dc1ed9a7e201fabe96fb7088fd3fdfc4.png";